import { defineStore } from 'pinia';
import api from '@/services/api';

const MULTIPART = { headers: { 'Content-Type': 'multipart/form-data' } };

const conImagenAbsoluta = (sentido, version) => {
  const baseURL = import.meta.env.VITE_URL_BASE_API || `${window.location.origin}/api`;
  if (!sentido.ImagenURL) return { ...sentido, ImagenURL: null };
  const url = `${baseURL}${sentido.ImagenURL.replace('/api', '')}`;
  return { ...sentido, ImagenURL: version ? `${url}?v=${version}` : url };
};

const buildFormData = ({ Descripcion, Activo, file } = {}) => {
  const fd = new FormData();
  if (Descripcion !== undefined) fd.append('Descripcion', Descripcion);
  if (Activo !== undefined) fd.append('Activo', String(Activo));
  if (file) fd.append('file', file);
  return fd;
};

export const useSentidoBobinadoStore = defineStore('sentidoBobinadoStore', {
  state: () => ({
    sentidoBobinadoList: [],
    sentidoBobinadoPersonalizadoList: [],
    page: 1,
  }),

  actions: {
    async findAllSentidoBobinadoHTTP({ incluir } = {}) {
      const params = { page: +this.page };
      if (incluir) params.incluir = incluir;
      const result = await api.get('/sentido-bobinado', { params });
      if (result && result.data) {
        this.sentidoBobinadoList.splice(
          0,
          this.sentidoBobinadoList.length,
          ...result.data.map((sentido) => conImagenAbsoluta(sentido)),
        );
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findPersonalizadosHTTP() {
      const result = await api.get('/sentido-bobinado/personalizados');
      if (result && result.data) {
        const version = Date.now();
        this.sentidoBobinadoPersonalizadoList = result.data.map((sentido) =>
          conImagenAbsoluta(sentido, version),
        );
        return true;
      }
      return false;
    },
    async createPersonalizadoHTTP({ Descripcion, file }) {
      const { data } = await api.post(
        '/sentido-bobinado',
        buildFormData({ Descripcion, file }),
        MULTIPART,
      );
      return data;
    },
    async updatePersonalizadoHTTP(codigo, { Descripcion, Activo, file }) {
      const { data } = await api.patch(
        `/sentido-bobinado/${codigo}`,
        buildFormData({ Descripcion, Activo, file }),
        MULTIPART,
      );
      return data;
    },
    async deletePersonalizadoHTTP(codigo) {
      const { data } = await api.delete(`/sentido-bobinado/${codigo}`);
      return data;
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.sentidoBobinadoList = [];
    },
  },
});
